import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useStore } from "../../app/stores/store";
import '../Pagos/Operaciones_style.css'
import { TableWithBrowserPagination, Column, Badge, MenuItem } from 'react-rainbow-components';

export default observer(function TablaReporteBanrural() {

    const { ReporteBanruralStore } = useStore();

    return (
        <div className="rainbow-p-bottom_xx-large">
            <TableWithBrowserPagination paginationAlignment="left" pageSize={20} data={ReporteBanruralStore.ReporteBanruralByCodigo} keyField="id" isLoading={ReporteBanruralStore.loadingInitial}>
                <Column header="Código Curso" field="codigoDeCurso" />
                <Column header="Documento Contable" field="numeroDocumentoContable" />
                <Column header="Número de Boleta" field="numeroBoleta" />
                <Column header="nombre" field="nombre" />
                <Column header="Curso" field="nombreCurso" />
                <Column header="monto" field="monto" />
                <Column header="fecha Pago" field="fechaPago" />
                <Column header="Tipo Pago" field="tipoPago" />
            </TableWithBrowserPagination>
        </div>
    )
})
